import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { getAppName } from '#app/containers/ThemeLoader';
import { useCurrentPageInfo } from '#app/containers/routes';

function DesktopTitlebar({ children }) {
  const appName = getAppName();
  const intl = useIntl();

  const pageInfo = useCurrentPageInfo();
  useEffect(() => {
    let pageTitle;
    if (pageInfo.formattedPage) {
      if (pageInfo.account) {
        pageTitle = intl.formatMessage(
          {
            defaultMessage: '{page} – {account}',
            description: 'Webpage title (logged in)',
          },
          {
            page: pageInfo.formattedPage,
            account: pageInfo.account,
          },
        );
      } else {
        pageTitle = intl.formatMessage(
          {
            defaultMessage: '{page} – {app}',
            description: 'Webpage title (not logged in)',
          },
          {
            page: pageInfo.formattedPage,
            app: appName,
          },
        );
      }
    } else {
      if (pageInfo.account) {
        pageTitle = intl.formatMessage(
          {
            defaultMessage: '{app} – {account}',
            description: 'Webpage title (logged in)',
          },
          {
            app: appName,
            page: pageInfo.formattedPage,
            account: pageInfo.account,
          },
        );
      } else {
        pageTitle = intl.formatMessage(
          {
            defaultMessage: '{app}',
            description: 'Webpage title (not logged in)',
          },
          {
            app: appName,
            page: pageInfo.formattedPage,
          },
        );
      }
    }
    document.title = pageTitle;
  }, [intl, pageInfo, appName]);

  return <>{children}</>;
}

export default DesktopTitlebar;
